export function fetchData(url, options) {
  return fetch((process.env.GATSBY_API_URL || '') + url, options);
}
